import {SortDirection} from "../../../data-structures/sort"
import {ColumnConfig, ColumnID, ColumnSettingsConfig} from "../../manager/columns/types"
import {SystemStatusGroup} from "../../../gd/const/system-status"
import {ViewType} from "../../../gd/const/views/view-type"
import TasksView_Filters from "./manager/filters/filters"
import ExportManagerProto from "../../manager/export/export-manager-proto"
import TasksViewManager from "./manager"
import TasksViewDataContainer from "./manager/data/data"
import {TasksView_Actions} from "./manager/actions"
import SessionUpdatesManager from "../../../gd/manager/delta-handler/session-updates-manager/session-updates-manager"
import ProjectSession from "../../../model2/project/project-session"
import {Table_LastRowMode} from "../table/components/last-row/@types"
import ItemModelV2 from "../../../model2/item2/item-model"
import TasksView_Columns from "./manager/columns/columns"
import {EntityType} from "../../../gd/const/item"
import SortingManagerMulti_V2 from "../../manager/sorting-manager/v2/sorting-manager-multi-v2";
import {SettingsVersion} from "../../common/settings-manager"
import TasksView_GroupBy from "./manager/group-by/group-by"
import {CardViewLayout} from "../../../gd-ui/card-view-selector/card-view-selector"
import TasksView_CollapseManager from "./manager/collapse-manager"
import {Board_AggregateParameters} from "../board/@types"
import TasksView_DNDManager from "./manager/dnd/manager"
import FieldProto from "../../../fields3/proto/field-proto"
import FieldAggregator from "../../../model2/item2/calculated/aggregators/aggregator"
import TasksView_Aggregate from "./manager/aggregate"
import TasksView_RequiredFields from "./manager/required-fields/required-fields"
import TasksView_BulkActionManager from "./manager/bulk-action/bulk-action-manager"
import {BackGround} from "../../../gd-app/panels/preferences-panel/settings-background/settings-background"
import TasksView_RowHeight from "./manager/row-height"

export enum TasksView_ManagerRootMode {
    SINGLE_PROJECT     = "project",             // case when we shouw data for a single project i.e. project table/board
    SINGLE_TAG         = "tag",                 // same as single project but tag
    MULTIPLE_PROJECTS  = "multiple-projects"    // i.e. custom view , portfolio etc...
}



export type SortConfig = {
    id              : fieldId | null,
    label           : string,
    defaultSort     : SortDirection
    info            : string
}

export type TasksViewAppSettings = {
    version?                : SettingsVersion

    templateId?             : ID    // this is view template ID (!) if set we use data from template
    inheritedFromProjectId? : ID

    columns?                : ColumnSettingsConfig[] // any // ColumnConfig[] // _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    systemStatusFilter?     : SystemStatusGroup, // used is task table to show hide archived tasks

    sorting?                : any,  // current sorting value
    sortBy?                 : any, // new format ??? or old ?

    grouping?               : any,  // current grouping value
    filters?                : any,
    areEmptyFoldersHidden?  : boolean,
    areEmptyGroupsHidden?   : boolean
    areAddRowsHidden?       : boolean
    highlightItemsMode?     : ItemsHighlightMode

    // Common ? List ?
    showSubfolders?         : any
    groupingType?           : any
    groupBy1?               : any
    groupBy2?               : any
    itemViewBorderPosition? : CardViewLayout
    background?             : BackGround
    showSubTasks?           : any  // true = show subtasks as separate items (cards on Board, rows on List/Table), false = nest subtasks under their parent task (per-view setting)

    // Board
    boardViewBorderPosition?: any // v2 parameter has been changed to itemViewBorderPosition
    showEmptyColumns?       : any
    showEmptyRows?          : any
    boardCardColorFieldId?  : any // v2 parameter has been changed to colorTasksFieldId
    boardViewSize?          : any
    columnsAggregate?       : Board_AggregateParameters
    rowsAggregate?          : Board_AggregateParameters

    boardViewColumnGroupBy? : any // v2 parameter has been changed to grouping
    boardViewRowGroupBy?    : any // v2 parameter has been changed to grouping
    boardViewRowType?       : any // v1 parameter has been changed to boardViewRowGroupBy
    boardViewColumnType?    : any // v1 parameter has been changed to boardViewColumnGroupBy

    // Gantt
    summaryMode?            : any
    zoom?                   : any
    startDateTodayDiff?     : any
    endDateTodayDiff?       : any
    eventItemColorFieldId?  : any
    itemIcons?              : any
    displayProgress?        : any
    showCriticalPath?       : any
    projectItemColorFieldId?       : any
    taskItemColorFieldId?       : any

    // Calendar
    eventTypes?          : any // Timeline too
    displayMode?          : any
    highlightPastDue?          : any
    showWeekNumber?          : any
    showCalendar?          : any
    colorProjectEventsFieldId?          : any
    colorPersonalEvents?          : any
    colorTasksFieldId?          : any // Tasks View color coding too
    colorMeetings?          : any
    colorCompanyEvents?          : any
    eventsShowTags?          : any
    projectEventsShowProject?          : any
    eventsUserIcon?          : any
    eventsIcon?          : any
    showOnlyWorkdays?          : any


    // Timeline
    groupInterval?          : any
    meetingEventDisplayFields?          : any
    personalEventDisplayFields?          : any
    projectEventDisplayFields?          : any
    taskEventDisplayFields?          : any


    // PAGE
    isFullWidth?            : boolean

    // MAP
    defaultAddressFieldId?  : boolean

}


// Config - old used in list board but not table
export type TasksViewConfig = {

    // REMOVE FROM HERE
    columns             : ColumnConfig[],       // all available columns array
    sortOptions         : SortConfig[],         // all available sort options

    defaultAppSettings  : TasksViewAppSettings  // defaultAppSettings import defaultAppSettings from "./settings/default-settings";

}

// deprecated - use SystemStatusGroup
export enum TableViewSystemStatus {
    OPEN        = 'open',
    CLOSED      = 'closed',
    ALL         = 'all'
}

export enum ItemsHighlightMode {
    NONE    = 'none',
    PROJECT = 'project',
}

export type TableView_LastRowAddParams = {
    mode                : Table_LastRowMode
    parentItemModel?    : ItemModelV2
}

// Generic constructor helper type
export type ClassConstructor<T, A extends any[] = any[]> = new (...args: A) => T;

export type TasksViewManagerConfig = {
    viewType                    : ViewType,

    ExportClass                 : ClassConstructor<ExportManagerProto, [TasksViewManager]>
    FiltersClass                : ClassConstructor<TasksView_Filters, [TasksViewManager]>
    SortingClass                : ClassConstructor<SortingManagerMulti_V2, [TasksViewManager]>
    DataClass                   : ClassConstructor<TasksViewDataContainer, [TasksViewManager, TasksViewManagerConfig]>
    ActionsClass                : ClassConstructor<TasksView_Actions, [TasksViewManager]>
    SessionUpdatesClass         : ClassConstructor<SessionUpdatesManager, [any]> //ISessionUpdatesHandler
    ColumnsClass                : ClassConstructor<TasksView_Columns, [TasksViewManager]>
    GroupingClass               : ClassConstructor<TasksView_GroupBy, [TasksViewManager]>
    CollapseClass               : ClassConstructor<TasksView_CollapseManager, [TasksViewManager]>
    DNDClass                    : ClassConstructor<TasksView_DNDManager, [TasksViewManager]>
    AggregateClass              : ClassConstructor<TasksView_Aggregate, [TasksViewManager]>
    RequiredFieldsClass         : ClassConstructor<TasksView_RequiredFields, [TasksViewManager]>
    BulkActionClass             : ClassConstructor<TasksView_BulkActionManager, [TasksViewManager]>
    RowHeightClass              : ClassConstructor<TasksView_RowHeight, [TasksViewManager]>

    rootMode                    : TasksView_ManagerRootMode
    rootProject?                : ProjectSession

    columnsOptions              : ColumnConfig[],   // all available columns array


    removeAllColumnsLabel?  : string        // default label =
    showResetColumnsWidth?  : boolean       // if true add/edit columns popover shows reset button (used in Board)
    showRemoveAllColumns?   : boolean       // if true add/edit columns shows remove all buttons (used in Board)
}

export type TableManagerConfig = {
    viewType                    :
        ViewType.PROJECT_TABLE
        | ViewType.CUSTOM_VIEW_TASKS_TABLE
        | ViewType.PROJECTS_PROJECTS_LIST
        | ViewType.PORTFOLIO_TABLE
        | ViewType.PROJECT_SUMMARY
        | ViewType.PORTFOLIO_SUMMARY
        | ViewType.REPORT_TIME_REPORTS

    DataClass                   : ClassConstructor<TasksViewDataContainer, [TasksViewManager, TasksViewManagerConfig]>
    SessionUpdatesClass?        : ClassConstructor<SessionUpdatesManager, [any]> // ISessionUpdatesHandler

    ExportClass?                : ClassConstructor<ExportManagerProto, [TasksViewManager]>
    FiltersClass?               : ClassConstructor<TasksView_Filters, [TasksViewManager]>
    SortingClass?               : ClassConstructor<SortingManagerMulti_V2, [TasksViewManager]>
    GroupingClass?              : ClassConstructor<TasksView_GroupBy, [TasksViewManager]>
    ColumnsClass?               : ClassConstructor<TasksView_Columns, [TasksViewManager]>
    RowHeightClass?             : ClassConstructor<TasksView_RowHeight, [TasksViewManager]>

    rootMode                    : TasksView_ManagerRootMode
    rootProject?                : ProjectSession

    columnsOptions?             : ColumnConfig[],   // all available columns array
}

export type BoardManagerConfig = Omit<TableManagerConfig, "viewType"> & {
    viewType                    :
        ViewType.PROJECT_BOARD
        | ViewType.CUSTOM_VIEW_BOARD
        | ViewType.PORTFOLIO_BOARD
    CollapseClass?              : ClassConstructor<TasksView_CollapseManager, [TasksViewManager]>
}

// export type BoardManagerConfig = {
//     viewType                    : ViewType.PROJECT_BOARD | ViewType.CUSTOM_VIEW_BOARD | ViewType.PORTFOLIO_BOARD,
//
//     DataClass                   : ClassConstructor<TasksViewDataContainer, [TasksViewManager, TasksViewManagerConfig]>
//     SessionUpdatesClass?        : ClassConstructor<SessionUpdatesManager, [any]> //ISessionUpdatesHandler
//
//     ExportClass?                : ClassConstructor<ExportManagerProto, [TasksViewManager]>
//     FiltersClass?               : ClassConstructor<TasksView_Filters, [TasksViewManager]>
//     SortingClass?               : ClassConstructor<SortingManagerMulti_V2, [TasksViewManager]>
//     ColumnsClass?               : ClassConstructor<TasksView_Columns, [TasksViewManager]>
//     GroupingClass?              : ClassConstructor<TasksView_GroupBy, [TasksViewManager]>
//     CollapseClass?              : ClassConstructor<TasksView_CollapseManager, [TasksViewManager]>
//
//     rootMode                    : TasksView_ManagerRootMode
//     rootProject?                : ProjectSession
//
//     columnsOptions?             : ColumnConfig[],   // all available columns array
// }

export type ListManagerConfig = {
    viewType:
        ViewType.PROJECT_LIST
        | ViewType.CUSTOM_VIEW_TASKS_LIST
        | ViewType.PORTFOLIO_LIST
        | ViewType.MY_TASKS_LIST
        | ViewType.MY_TIME

    DataClass                   : ClassConstructor<TasksViewDataContainer, [TasksViewManager, TasksViewManagerConfig]>
    SessionUpdatesClass?        : ClassConstructor<SessionUpdatesManager, [any]> // ISessionUpdatesHandler

    ExportClass?                : ClassConstructor<ExportManagerProto, [TasksViewManager]>
    FiltersClass?               : ClassConstructor<TasksView_Filters, [TasksViewManager]>
    SortingClass?               : ClassConstructor<SortingManagerMulti_V2, [TasksViewManager]>
    GroupingClass?              : ClassConstructor<TasksView_GroupBy, [TasksViewManager]>
    ColumnsClass?               : ClassConstructor<TasksView_Columns, [TasksViewManager]>
    RowHeightClass?             : ClassConstructor<TasksView_RowHeight, [TasksViewManager]>

    rootMode                    : TasksView_ManagerRootMode
    rootProject?                : ProjectSession

    columnsOptions?             : ColumnConfig[],   // all available columns array
}

export enum Table_RowType {
    ITEM        = 'item',       // regulgar item like task project event etc
    LAST_ROW    = 'last-row',   // used for aggregation and inline add
    SHOW_MORE   = 'show-more',  // list view X items more
    NOT_FOUND   = 'not-found',  // I dont think we need it ????
    SUB_HEADER  = 'sub-header', // optional slot rendered as first grid row, scrolls with content
}

export type Table_Row = {
    type                    : Table_RowType

    // Table_RowType.ITEM
    item?                   : {
        listItem                : ItemModelV2
        allowExpand             : boolean
    }

    // Table_RowType.LAST_ROW
    inlineAdd?              : {
        addType                 : EntityType | null
        initialMode?            : Table_LastRowMode
        parentFolderId?         : ID | null
        parentTaskId?           : ID | null
        isAddAllowed?           : boolean
        isRoot?                 : boolean
        sortPosition?           : number
        parentItem?             : ItemModelV2
        parentProjectId?        : ID
        isNewTaskAvailable?     : boolean
        isNewProjectAvailable?  : boolean
    }

    // Table_RowType.SHOW_MORE
    more?                   : {
        parentItem              : ItemModelV2
        moreCounter             : number    // used for show more only
    }

    level?                  : number
    isFirst?                : boolean
    isLast?                 : boolean
}

export type FieldAggregationConfig = {
    field       : FieldProto
    aggregator? : FieldAggregator
}

export enum Header_Type {
    TABLE   = 'table',
    LIST    = 'list',
}

export type BreakdownConfig = {
    fieldId : ID
    value   : any
}

